import Project from "../main.js";

export class Galleries {
	constructor() {
		this.project = new Project();

		this.DOM = {
			galleriesSection: this.project.DOM.body.querySelector('.galleries'),
			galleries: [...this.project.DOM.body.querySelectorAll('.galleries__list__gallery')],
		}

		if(!this.DOM.galleriesSection || !this.DOM.galleries) {
			return null;
		}

		this.init()
	}

	init() {
		this.instances = {
			galleries: this.DOM.galleries.map((gallery) => new Gallery(gallery))
		}
	}
}

class Gallery {
	constructor(gallery) {
		this.project = new Project();

		this.DOM = {
			swiper: gallery,
			swiperPrevBtn: gallery.querySelector('.galleries__list__gallery__button--prev'),
			swiperNextBtn: gallery.querySelector('.galleries__list__gallery__button--next'),
			swiperList: gallery.querySelector('.galleries__list__gallery__scroller'),
			swiperListInner: gallery.querySelector('.galleries__list__gallery__list'),
		}

		if(!this.DOM.swiper) {
			return null;
		}

		this.init();
	}

	init() {
		this.handleEvents()
	}

	handleEvents() {
		this.DOM.swiperPrevBtn.addEventListener('click', () => this.scroll(-1));
		this.DOM.swiperNextBtn.addEventListener('click', () => this.scroll(1));

		this.DOM.swiperList.addEventListener('scroll', () => this.checkEdges());
		this.project.hooks.resize.push(this.checkEdges.bind(this))
	}

	scroll(direction) {
		const delta = direction * this.DOM.swiperList.clientWidth;
		this.DOM.swiperList.scrollBy({ left: delta, behavior: 'smooth' });
	}

	checkEdges() {
		this.DOM.swiperPrevBtn.toggleAttribute('disabled', this.atStartEdge());
		this.DOM.swiperPrevBtn.setAttribute('aria-disabled', this.atStartEdge());

		this.DOM.swiperNextBtn.toggleAttribute('disabled', this.atEndEdge());
		this.DOM.swiperNextBtn.setAttribute('aria-disabled', this.atEndEdge());
	}

	atStartEdge() {
		return this.DOM.swiperList.scrollLeft <= 1;
	}

	atEndEdge() {
		return this.DOM.swiperList.scrollLeft + this.DOM.swiperList.clientWidth >= this.DOM.swiperList.scrollWidth - 1;
	}
}